import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApiService } from 'services/api.service';

@Component({
  template: '',
  standalone: true
})
export abstract class BaseClientFormComponent implements OnInit {
  @Output() editModeChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  isEditMode: boolean = false;
  submitAttempted: boolean = false;
  form: FormGroup;

  constructor(
    protected formBuilder: FormBuilder,
    protected apiService: ApiService
  ) {
    this.form = this.formBuilder.group({});
  }

  ngOnInit() {
    this.fillForm();
  }

  abstract fillForm(): void;

  setIsEditMode(isEditMode: boolean) {
    this.isEditMode = isEditMode;
    this.editModeChanged.emit(isEditMode);
  }

  submit(): void {
    this.submitAttempted = true;
  }

  shouldRenderError(key: string): boolean {
    const control = this.form.get(key);
    if (control) {
      return control.invalid && control.touched && !!control?.errors;
    }

    return false;
  }

  onDateSelected(date: string, key: string): void {
    this.form.get(key)?.markAsDirty();
    this.form.get(key)?.markAsTouched();
    this.form.get(key)?.setValue(date);
  }
}
